import $ from 'jquery';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import axios from 'axios';


import {
    CREATE_QUOTE,
    GET_QUOTES,
    UPDATE_QUOTE,
    ASSIGNED_SERVICES,
    get_headers,
    VIEW_QUOTE_PDF_URL,
    SHARE_QUOTE_URL,
    SERVICE_PACKAGE_BY_PROJECT,
    ASSIGN_PACKAGES_TO_QUOTE
} from '@/utils/constants/constants.js';

import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';

export default {
    name: 'QuoteManagement',
    mixins: [alert_mixin, formatting_mixins],
    data: () => ({
        headers: get_headers(),
        project_id: sessionStorage.getItem('project_id'),
        lead_id: null,
        forms: [],
        current_form: {
            id: null,
            quote_number: '',
            status: '',
            date_issued: '',
            valid_until: '',
        },
        table_safe_packages: [],
        services_table: null,
        quotes_table: null,
        isUnassign: false,
        assigned_services: [],
        preview_url: null,
    }),
    mounted() {
        this.lead_id =
            this.$route.params.lead_id ??
            this.$route.params.id ??
            this.$route.query.lead_id ??
            null;

        if (!this.lead_id) {
            this.show_error("No lead ID found. Check your route.");
        }
        this.get_quotes();
        this.load_services(true);
    },
    methods: {
        open_create_modal() {
            this.current_form = {
                quote_number: '',
                status: '',
                date_issued: '',
                valid_until: '',
            };
        },

        open_edit_modal(form) {
            this.current_form = { ...form };
        },

        initialize_services_table() {
            this.$nextTick(() => {
                const table = $('#trust_types_table');
                if (!table.length || !table[0]) return;

                const rows = table.find('tbody tr').filter((_, tr) => {
                    return $(tr).find('td').length === 5;  // Only data rows
                });

                if (rows.length === 0) return;

                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }

                this.trustTypesDataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 5,
                });
            });
        },


        destroy_services_data_table() {
            if (this.trustTypesDataTable) {
                this.trustTypesDataTable.destroy();
                this.trustTypesDataTable = null;
            }
        },

        async open_assign_modal(form) {
            this.current_form = { ...form };

            try {
                await this.load_services(false);

                const assigned_services = await this.get_assigned_services(form.id);

                // Reset all selections and quantities
                this.table_safe_packages.forEach(package_service => {
                    package_service.selected = false;
                    package_service.services.forEach(service => {
                        service.quantity = 1;
                    });
                });

                // Apply assigned services to correct package and service
                assigned_services.forEach(assigned => {
                const assigned_package_service_id = assigned.service_package?.id;
                const assigned_service_id = assigned.service?.id;

                const matched_package_service = this.table_safe_packages.find(package_service => package_service.id === assigned_package_service_id);
                if (matched_package_service) {
                    matched_package_service.selected = true;

                    const matched_service = matched_package_service.services.find(service => service.id === assigned_service_id);
                    if (matched_service) {
                        matched_service.quantity = assigned.quantity;
                    }
                }
                });

            } catch (error) {
                const message = error.response?.data?.message || error.message;
                this.show_error("Failed to open assign modal: " + message);
            }
        },


        


        
        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },

        async load_services(initialize_table = false) {
            const project_id = parseInt(this.project_id, 10);
            try {
                const response = await axios.get(SERVICE_PACKAGE_BY_PROJECT, { 
                    headers: this.headers, 
                    params: { project_id } 
                });

                const response_data = response.data;
                if (response_data.status === 'success') {
                    this.trust_types = response_data.data;
                    this.transform_services_data(initialize_table);
                } else {
                    this.show_error('Error monitoring types retrieval');
                }

            } catch (error) {
                this.show_error("Error loading services: " + (error.response?.data?.message || error.message));
            }
        },

        transform_services_data(initialize_table = false) {
            if (this.trust_types.length > 0) {
                this.table_safe_packages = this.trust_types.map(package_service => ({
                    id: package_service.id,
                    name: package_service.name,
                    description: package_service.description,
                    base_price: package_service.base_price,
                    selected: false,
                    services: (package_service.services || []).map(service => ({
                        id: service.id,
                        name: service.name,
                        description: service.description,
                        price: service.price,
                        quantity: 1
                    }))
                }));

            }

            if (initialize_table) {
                this.initialize_services_table();
            }
        },



        async open_preview_quote(form) {
            if (!form.id) {
                this.show_error("Quote ID is missing.");
                return;
            }

            this.current_form = { ...form };

            try {
                const response = await axios.get(VIEW_QUOTE_PDF_URL, {
                    headers: this.headers,
                    params: { quote_id: form.id },
                    responseType: 'blob',
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                this.preview_url = url;
            } catch (error) {
                this.show_error("Please assign a service package to this quote before previewing.");
            }
        },


        create_quotes() {

            if (!this.current_form.date_issued) {
                this.show_error('Date issued is required.');
                return;
            }

            if (!this.current_form.valid_until) {
                this.show_error('Valid until date is required.');
                return;
            }

            const payload = {
                ...this.current_form,
                lead_id: this.lead_id
            };

            axios.post(CREATE_QUOTE, payload, { headers: this.headers })
                .then(() => {
                    this.close_modal('create_quote');
                    this.show_success('Quote created successfully.');
                    window.location.reload()
                })
                .catch(error => {
                    this.show_error('Create failed: ' + (error.response?.data?.message || error.message));
                    this.close_modal('create_quote');
                });
        },

        update_quotes() {
            // Validate required fields (no longer checking form_name and form_description)
            if (!validate_non_empty_string(this.current_form.quote_number)) {
                this.show_error('Quote number is required.');
                return;
            }

            if (!this.current_form.date_issued) {
                this.show_error('Date issued is required.');
                return;
            }

            if (!this.current_form.valid_until) {
                this.show_error('Valid until date is required.');
                return;
            }

            // Prepare the payload
            const payload = {
                lead_id: this.lead_id,
                quote_id: this.current_form.id,
                date_issued: this.current_form.date_issued,
                valid_until: this.current_form.valid_until,
            };

            // Send the update request
            axios.post(UPDATE_QUOTE, payload, { headers: this.headers })
                .then(() => {
                    this.close_modal('edit_quote');  // Close the modal
                    this.show_success('Quote updated successfully.');
                    window.location.reload()
                })
                .catch(error => {
                    this.show_error('Update failed: ' + (error.response?.data?.message || error.message));
                });
        },

        save_assignment() {
            if (!this.current_form.id) {
                this.show_error("Quote ID is missing.");
                return;
            }

            const assigned_packages = [];

            this.table_safe_packages.forEach(package_service => {
                if (!package_service.selected) return;

                const selected_services = package_service.services
                    .filter(service => service.quantity && service.quantity > 0)
                    .map(service => ({
                        service_id: service.id,
                        quantity: service.quantity
                    }));

                if (selected_services.length) {
                    assigned_packages.push({
                        package_id: package_service.id,
                        services: selected_services
                    });
                }
            });

            if (!assigned_packages.length) {
                this.show_error("Please select at least one package and set service quantities.");
                return;
            }

            const payload = {
                quote_id: this.current_form.id,
                packages: assigned_packages
            };

            axios.post(ASSIGN_PACKAGES_TO_QUOTE, payload, { headers: this.headers })
                .then(() => {
                    this.show_success("Service packages assigned successfully.");
                    this.close_modal('assign_services');
                    window.location.reload();
                })
                .catch(error => {
                    const msg = error.response?.data?.message || error.message;
                    this.show_error("Assignment failed: " + msg);
                });
        },




        send_quote_email() {
            const quote_id = this.current_form?.id;
            if (!quote_id) {
                this.show_error("Quote ID is missing.");
                return;
            }

            axios.post(SHARE_QUOTE_URL, {
                quote_id: quote_id
            }, { headers: this.headers })
                .then(response => {
                    const { status, message } = response.data;
                    if (status === "success") {
                        this.show_success("Quote sent via email.");
                    } else {
                        this.show_error(message || "Error sending email.");
                    }
                })
                .catch(error => {
                    this.show_error("Failed to send email: " + (error.response?.data?.message || error.message || "Unknown error"));
                });

        },

        get_quotes() {
            this.destroy_data_table();
            this.forms = [];
            axios.get(GET_QUOTES, {
                headers: this.headers,
                params: { lead_id: this.lead_id }
            })
                .then(response => {
                    const parsed_response = response.data;
                    if (parsed_response.data && parsed_response.data.length > 0) {
                        this.forms = parsed_response.data;
                        this.transform_forms_data();
                    } else {
                        this.forms = [];
                    }
                })
                .catch(error => {
                    this.show_error("Error loading quotes: " + (error.response?.data?.message || error.message));
                });
        },

        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#forms_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }
                
                // Destroy the existing DataTable instance if it exists
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }
                
                // Store the DataTable instance
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        transform_forms_data() {
            if (this.forms.length > 0) {
                const TABLE_FORM_DATA = this.forms.map(form => ({
                    "id": form.id,
                    "quote_number": form.quote_number,
                    "code": form.quote_status.code,
                    "date_issued": this.format_date(form.date_issued),
                    "valid_until": this.format_date(form.valid_until),
                    "date_created": this.format_date(form.date_created)
                }));
                this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_form_list = TABLE_FORM_DATA;
            }
            this.$nextTick(() => {
                this.initialize_data_table();
            });

        },

        async get_assigned_services(quote_id) {
            const response = await axios.get(ASSIGNED_SERVICES, {
                headers: this.headers,
                params: { quote_id }
            });
            return response.data?.data || [];
        }


    }
};
